<template>
  <RevCard class="flex flex-col justify-between p-16" data-test="step">
    <div>
      <RevTag
        v-if="shouldDisplayStatus"
        class="mb-8"
        :label="formattedStep.status.label"
        :variant="formattedStep.status.variant"
      />
      <div class="body-1-bold mb-8">{{ formattedStep.title }}</div>
      <div class="body-2 mb-8">{{ formattedStep.description }}</div>
      <div
        v-if="formattedStep.estimatedDuration"
        class="text-action-default-low body-2"
      >
        {{ formattedStep.estimatedDuration }}
      </div>
    </div>
    <div class="text-right">
      <RevButton
        class="mt-20"
        size="small"
        :target="formattedStep.targetValue"
        :to="formattedStep.link"
        variant="secondary"
      >
        {{ formattedStep.buttonLabel }}
      </RevButton>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevTag } from '@ds/components/Tag'

import type { SelfOnboardingStep } from '~/api/seller-self-onboarding/types'
import { useListingPagePreference } from '~/scopes/listings/pages/listingsV2/composables/useListingPagePreference'

import { formatStep } from './OnboardingStep.utils'

const props = defineProps<{
  step: SelfOnboardingStep
}>()

const { isListingsPageV2Default } = useListingPagePreference()

const formattedStep = computed<ReturnType<typeof formatStep>>(() =>
  formatStep(props.step, isListingsPageV2Default.value),
)

const shouldDisplayStatus = computed(() => !props.step.displayAsHeadline)
</script>
